import { trace } from 'rytm-helpers'

export const getWorkerPerc = async () => {
  const params = {
    method: 'GET',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  }
  const response = await fetch("/amznserv/v1/amzn_worker/wcperc", params)
  const responseData = await response.json()
  const dataObj = responseData ? responseData.data[0] : {}
  return dataObj.perc
}

// let currentObj
// /**
//  * 
//  * @param {*} obj 
//  */
// const sendWorkerProcess = async (payload) => {
//   const params = {
//     method: 'POST',
//     headers: {
//       'Accept': 'application/json',
//       'Content-Type': 'application/json'
//     },
//     body: payload ? JSON.stringify(payload) : null
//   }
//   const response = await fetch("/amznserv/v1/amzn_worker", params)
//   const responseData = await response.json()
// }


// /**
//  * Start a worker process
//  * @param {*} obj 
//  */
// export const objectViewStart = (obj) => {
//   currentObj = obj
//   const d = new Date()
//   currentObj.timecode = d.getTime()
// }
// /**
//  * Start a worker process
//  */
// export const objectViewStop = () => {
//   if (currentObj) {
//     const d = new Date()
//     currentObj.duration = d.getTime() - currentObj.timecode;
//     sendWorkerProcess(currentObj)
//   }
//   currentObj = null
// }

